import { WINDOW_RESIZE } from '../types';

const windowSize = (
  state = {
    width: null,
    height: null,
  },
  action
) => {
  switch (action.type) {
    case WINDOW_RESIZE:
      return { width: action.payload.width, height: action.payload.height };

    default:
      return state;
  }
};

export { windowSize };
